<template>
    <div class="rightContent">
        <div class="paramContent bb1">
            <div class="h30">
                <span class="mr50">
                    <span style="display:inline-block;width:75px">{{ $t('param.name') }}</span>
                    {{ rightHeaderObj.name }}</span
                >
                <span>
                    <span style="display:inline-block;width:75px">{{ $t('param.code') }}</span>
                    {{ rightHeaderObj.code }}
                </span>
            </div>
            <div class="desc h30">
                <span>
                    <span style="display:inline-block;width:75px">{{ $t('param.desc') }}</span>
                </span>
                <span style="margin-left:5px">{{ rightHeaderObj.desc }}</span>
            </div>
        </div>
        <div class="paramSearch bb1 uk-flex">
            <el-input type="text" style="width:250px" :placeholder="$t('param.param_content_name_placeholder')" v-model="listQuery.name" clearable></el-input>
            <el-button type="primary" icon="el-icon-search" @click="searchFn" class="btn" style="border-right:none !important"></el-button>

            <el-button type="primary" @click="handleAdd" icon="el-icon-plus" class="btn" style="border-left:none !important"></el-button>
        </div>
        <div class="paramList">
            <el-table stripe ref="multipleTable" :data="tableData" :height="tableHeight" :header-cell-style="headCellStyle" :cell-style="bodyCellStyle" row-key="id">
                <el-table-column :label="$t('param.param_content_name')" show-overflow-tooltip prop="name" />
                <el-table-column :label="$t('param.param_content_code')" show-overflow-tooltip prop="code" />
                <el-table-column :label="$t('param.param_contetn_value')" show-overflow-tooltip prop="content" />
                <el-table-column :label="$t('public.table_operation')" width="120">
                    <template #default="{ row }">
                        <el-button type="text" size="small" @click="loraEdit(row)" :title="$t('tbopt.edit')" :icon="$store.state.icons.compiles"></el-button>
                        <el-button type="text" size="small" @click="handsdelete(row)" v-has="['deleteforward']" :icon="$store.state.icons.omit" :title="$t('tbopt_delete')"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 编辑&新增 -->
        <Dialog :isShow.sync="isShow" :title="title" :optareStatus="optareStatus" :formRow="formRow" :typeText="typeText" :typeId="typeId" ref="diaLog" :typeParam="true" />
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
import Dialog from './DialogRight.vue';
import Sortable from 'sortablejs';
import { paramContentList, paramContentUpdateOne, paramContentDelR, paramContentUpdateSeq } from '@/api/modules/params.js';
export default {
    components: {
        Dialog
    },
    data() {
        return {
            rightHeaderObj: {},
            tableData: [],
            listQuery: {
                typeId: null,
                name: null
            },
            // 弹窗框
            isShow: false,
            title: '',
            optareStatus: '',
            formRow: {},
            tableHeight: '100%',
            typeText: '',
            typeId: 0,
            copyArray: []
        };
    },
    mounted() {
        bus.$on('leftContentFn', item => {
            this.rightHeaderObj = { ...item };

            this.typeText = item.name;

            this.typeId = item.id;

            this.listQuery.typeId = item.id;

            this.getList();
            // 行拖拽
            this.rowDrop();
        });
    },
    methods: {
        rowDrop() {
            const that = this;
            const tbody = document.querySelector('.el-table__body-wrapper tbody');
            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    const currRow = that.tableData.splice(oldIndex, 1)[0];
                    that.tableData.splice(newIndex, 0, currRow);
                    that.seqFn(that.copyArray[newIndex], that.tableData[newIndex]);
                }
            });
        },
        seqFn(item, row) {
            paramContentUpdateSeq({
                typeId: this.typeId,
                targetId: item.id,
                currentId: row.id
            }).then(async ({ state }) => {
                await this.$resultHandle(state);
            });
        },
        getList() {
            paramContentList(this.listQuery).then(({ result }) => {
                this.tableData = result;
                this.copyArray = [...result];
            });
        },
        searchFn() {
            this.getList();
        },
        handleAdd() {
            this.optareStatus = 'add';
            this.isShow = true;
            this.title = 'param.title_add_param_content';
            this.$nextTick(() => {
                this.$refs.diaLog.clearValidate();
            });
        },
        loraEdit(row) {
            this.title = `${this.$t('public.tbopt_edit')}[${row.name}]`;
            this.$nextTick(() => {
                this.$refs.diaLog.clearValidate();
            });
            this.optareStatus = 'edit';
            this.isShow = true;
            paramContentUpdateOne({ id: row.id }).then(({ result }) => {
                this.formRow = result;
            });
        },
        handsdelete(row) {
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    paramContentDelR({ ids: row.id }).then(({ result, state }) => {
                        if (result === 1) {
                            this.$message.success($t('param.code_1'));
                            this.getList();
                        } else if (result === 3) {
                            this.$message.error($t('param.code_3'));
                        } else if (result === 0) {
                            this.$message.error($t('param.code_0'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.rightContent {
    height: 100%;
    width: calc(100% - 300px);
    display: flex;
    flex-direction: column;

    .bb1 {
        border-bottom: 1px solid #ccc;
    }

    .paramContent {
        padding: 15px;
        box-sizing: border-box;

        .desc {
            display: flex;
        }

        .h30 {
            line-height: 30px;
        }

        .mr50 {
            margin-right: 50px;
        }
    }

    .paramSearch {
        height: 50px;
        padding-left: 15px;
        display: flex;
        align-items: center;

        //  padding: px;
        ::v-deep .el-icon-plus {
            color: #fff !important;
        }
    }

    .paramList {
        flex: 1;
        padding: 15px;
        box-sizing: border-box;
    }
    ::v-deep .btn {
        border-radius: 0px !important;
    }
}
</style>
